import { __assign } from './external/tslib/tslib.es6.js';
import * as React from 'react';

var SvgAlertTriangleOutline = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m21.867 19.51-9-17a.987.987 0 0 0-.87-.51c-.34 0-.68.17-.87.51l-9 17c-.37.67.11 1.49.87 1.49h18c.76-.01 1.24-.83.87-1.49Zm-17.21-.52 7.34-13.86 7.34 13.86H4.657Zm6.34-4h2l-.02-5h-2l.02 5Zm.04 1h2v2h-2v-2Z", fill: "currentColor" }))); };

export { SvgAlertTriangleOutline as default };
